import type { RootState } from '@shared/redux/root-state';
import type { CheckList } from './types';

export const appSettingsSelectors = {
  selectIsPrimarySidebarCollapsed: (state: RootState) => state.appSettings.primarySidebarCollapsed,
  selectSoundVolume: (state: RootState) => state.appSettings.soundVolume,
  selectSoundSpeed: (state: RootState) => state.appSettings.soundSpeed,
  selectChecklist: (state: RootState) => state.appSettings.checklist,
  selectLanguage: (state: RootState) => state.appSettings.language,
  selectTheme: (state: RootState) => state.appSettings.theme,
  selectChecklistByProjectId: (projectId: number) => (state: RootState) =>
    state.appSettings.checklist.find((checklist: CheckList) => checklist.projectId === projectId),
};
